angular.module('rjmNg.common.api').factory 'ThirdPartyConnectionUtils', [
  'AbstractConnections'
  (
    AbstractConnections
  ) ->

    (clientId) ->
      AbstractConnections(clientId, "third-party")

]
